

function getMonths() {
	return [ 
		{id:1, name: 'enero', days: 31},
		{id:2, name: 'febrero', days: 28},
		{id:3, name: 'marzo', days: 31},
		{id:4, name: 'abril', days: 30},
		{id:5, name: 'mayo', days: 31},
		{id:6, name: 'junio', days: 30},
		{id:7, name: 'julio', days: 31},
		{id:8, name: 'agosto', days: 31},
		{id:9, name: 'septiembre', days: 30},
		{id:10, name: 'octubre', days: 31},
		{id:11, name: 'noviembre', days: 30},
		{id:12, name: 'diciembre', days: 31}
	];
}

function getMonth(num) {
	if (num == 1)	return 'enero';
	if (num == 2)	return 'febrero';
	if (num == 3)	return 'marzo';
	if (num == 4)	return 'abril';
	if (num == 5)	return 'mayo';
	if (num == 6)	return 'junio';
	if (num == 7)	return 'julio';
	if (num == 8)	return 'agosto';
	if (num == 9)	return 'septiembre';
	if (num == 10)	return 'octubre';
	if (num == 11)	return 'noviembre';
	if (num == 12)	return 'diciembre';
}

function getMonthShort(num) {
	if (num == 1)	return 'ene.';
	if (num == 2)	return 'feb.';
	if (num == 3)	return 'marzo';
	if (num == 4)	return 'abril';
	if (num == 5)	return 'mayo';
	if (num == 6)	return 'junio';
	if (num == 7)	return 'julio';
	if (num == 8)	return 'agosto';
	if (num == 9)	return 'sept.';
	if (num == 10)	return 'oct.';
	if (num == 11)	return 'nov.';
	if (num == 12)	return 'dic.';
}

function getTimeHour(str) {
	let d = new Date(str);

	let hours = d.getHours();
	if (hours < 10) {
		hours = '0' + hours;
	}

	let minutes = d.getMinutes();
	if (minutes < 10) {
		minutes = '0' + minutes;
	}

	let final = d.getDate() + ' de ' + this.getMonthFactor(d.getMonth()) + ' de ' + d.getFullYear() + ' a las ' + hours + ':' + minutes + ' hrs.';
	return final;
}

function getShort(num) {
	let tempo = Number(num + 1);
	if (tempo < 10) {
		return '0' + tempo;
	}
	return tempo;
}

function getTime(str) {
	let d = new Date(str);

	let hours = d.getHours();
	if (hours < 10) {
		hours = '0' + hours;
	}

	let minutes = d.getMinutes();
	if (minutes < 10) {
		minutes = '0' + minutes;
	}

	let final = d.getDate() + ' / ' + this.getShort(d.getMonth()) + ' / ' + d.getFullYear();
	return final;
}

function amigableHour(str) {
	let tempo = Number(str.substr(0,2));
	if (tempo > 12) {
		return (tempo - 12) + str.substr(2,3);
	}
	return str
}

function amigableDate(dt) {
	return dt.substr(8,2) + ' de ' + this.getMonthName(dt.substr(5,2)) + ' de ' + dt.substr(0,4);
}

function getMeridian(value) {
	let hour = value.substr(0,2);

	if (hour >= 12) {
		return 'pm';
	} else {
		return 'am';
	}
}

function getFormatted(dt) {
	let day = new Date(dt).getDate();
	let month = new Date(dt).getMonth() + 1;
	let year = new Date(dt).getFullYear();
	let hour = new Date(dt).getHours();
	let minutes = new Date(dt).getMinutes();

	if (minutes < 10) {
		minutes = '0' + minutes;
	}

	if (day < 10) {
		day = '0' + day;
	}

	if (month < 10) {
		month = '0' + month;
	}
	
	// return day + ' de ' + getMonthFactor(month) + ' de ' + year + ' / ' + amigableHour(hour + ':' + minutes) + ' ' + getMeridian(hour + ':' + minutes);
	return month + '/' + day + '/' + year;
}

export default {getFormatted}












